module.exports = __webpack_public_path__ + "img/wand-magic-sparkles.a8d41730.svg";